export default import.meta.ROLLDOWN_FILE_URL_npgTDu$cVqgJQrMI91c9kQ